// OverlayPortal — mounts viewport overlays (.modal-back scrims, and any
// future fixed full-screen chrome) OUTSIDE the route component tree.
//
// Why a portal at all: overlays were rendered inline where they're used,
// which is almost always a later child of the route's `space-y-*` wrapper.
// Tailwind's space-y rule (`> :not([hidden]) ~ :not([hidden])`) puts
// `margin-top` on every later sibling — and margins apply to
// `position: fixed` boxes too, so the "full-viewport" scrim was pushed
// down (top:0 + margin-top) and shortened (bottom:0 honours the margin),
// leaving an un-dimmed strip of topbar at the top of the screen. Inline
// rendering also breaks whenever any ancestor grows a transform/filter/
// backdrop-filter (those turn the ancestor into the containing block for
// fixed descendants). Portalling out of the route tree ends the whole
// bug class.
//
// Why NOT document.body: the operator workspace re-binds the design
// tokens to the light `--opx-*` palette on `.admin-main` (see app.css).
// A modal portalled to <body> falls back to the root dark palette and
// renders as a dark card over the light console. The portal target
// #overlay-root lives INSIDE `.admin-main` (see routes/_app.tsx) so
// dialogs keep the light tokens; <body> is only the fallback for any
// future overlay opened outside the admin shell (e.g. a login-flow
// dialog), where the dark root palette is the correct one anyway.
import { createPortal } from "react-dom";

export const OVERLAY_ROOT_ID = "overlay-root";

export function OverlayPortal({ children }: { children: React.ReactNode }) {
  const target = document.getElementById(OVERLAY_ROOT_ID) ?? document.body;
  return createPortal(children, target);
}
